export default __webpack_public_path__ + "static/media/DSCN6124 (1).fa97d1ef.jpg";